import { ApiResponse } from "@/types";
import { createQueryString } from "@/utils/filterParams";
import api from "./api";

type StoreInspectionResult = {
  id: number;
  survey_date: string;
  sv_name: string;
  store_name: string;
  pdf: { name: string; type: string };
};

export type StoreInspectionDetail = {
  id: number;
  survey_date: string;
  sv_name: string;
  store_name: string;
  email?: string;
  address?: string;
  recipient_set_name?: string;
  sender_emails: string[];
  cc_emails: string[];
  violation?: number;
  oral_warning?: number;
  thorough_explanation: boolean;
  business_certificate_sticker: boolean;
  violations: {
    id: number;
    content: string;
    eviolation_detail?: string;
    comment?: string;
    place?: string;
    detail?: string;
    attachments: { id: number; name: string; url: string }[];
  }[];
};

const storeInspectionService = {
  getStoreInspectionResults: async (params: {
    page?: number;
    limit?: number;
    date_from?: string;
    date_to?: string;
  }): Promise<ApiResponse<StoreInspectionResult[]>> => {
    const paramsString = createQueryString({ page: 1, limit: 10, ...params });
    const response = await api.get(
      `/store/my-store-inspections?${paramsString}`,
    );
    return {
      data: Array.isArray(response.data.data) ? response.data.data : [],
      status: response.data.statusCode || 200,
      pagination: response.data.pagination,
      message: response.data.message,
    };
  },

  getStoreInspectionResultById: async (
    id: number,
  ): Promise<StoreInspectionDetail> => {
    const response = await api.get(`/store/my-store-inspections/${id}`);
    return response.data.data;
  },
};

export { storeInspectionService };
